import { environment } from "src/environments/environment";
import { USER_ROLES } from "../../services/api.service";

export class TalentUserAdapter {

  static calculateTalentScore(data) {
    const jobTitleValid = data?.scoreExperience ? data?.scoreExperience.some(v => v.key === 'job_title_validation' && v.checked) : false;
    const talentSpecialScore = {
      experience: [
        // { label: 'Job title', key: 'profession', checked: true },
        { label: 'Job title validation', key: 'validation', checked: jobTitleValid },
        { label: 'Soft skills', key: 'soft_skills', checked: true },
        { label: 'Hard skills', key: 'hard_skills', checked: data.hardSkills && data.hardSkills.length },
        {
          label: 'Social Links', key: 'resume_links', checked: !!(data.profile.details.socials.linkedIn || data.profile.details.socials.gitHub
            || data.profile.details.socials.stackOverflow || data.profile.details.socials.dribble || data.profile.details.socials.website), hint: 'talentSocial'
        },
        { label: 'Work experience', key: 'work_experience', checked: !!data.profile.details.workExperiences.filter(item => item.companyName).length },
        { label: 'Your location', key: 'location', checked: !!data.profile.details.country },
        { label: 'Language', key: 'language', checked: !!data.profile.details.languages.filter(item => item.name).length },
        { label: 'Education', key: 'education', checked: !!data.profile.details.educationDegree }
      ],
      expectations: [
        { label: 'Salary expectations', key: 'salary', checked: !!data.profile.expectations.salaryAmount },
        { label: 'Workplace', key: 'workplace', checked: !!data.profile.expectations.workPlace },
        { label: 'Employment type', key: 'employment_type', checked: !!data.profile.expectations.employmentType },
        { label: 'Relocation possibility', key: 'relocation', checked: data.profile.expectations.relocation !== null },
        { label: 'Domains', key: 'domains', checked: !!(data.profile.expectations.domains && data.profile.expectations.domains.length) },
        {
          label: 'Preferred company', key: 'preferred_company', checked: !!(data.profile.expectations.preferredCompanyType
            || data.profile.expectations.preferredCompanySize)
        }
      ]
    };
    let total = 20;
    if (jobTitleValid) {
      total = total + 10;
    }
    const experienceScore = talentSpecialScore.experience.filter(item => item.checked).length * 5;
    total = total + experienceScore;
    const expectationsScore = talentSpecialScore.expectations.filter(item => item.checked).length * 5;
    total = total + expectationsScore;
    return { total, ...talentSpecialScore };
  }

  static calculateTalentScoreV2(data) {
    let talentSpecialScore = {
      total: data?.score ? data.score : 25,
      expectations: null,
      experience: null
    };
    if (data?.scoreExpectations) {
      talentSpecialScore = { ...talentSpecialScore, expectations: data?.scoreExpectations }
    }
    if (data?.scoreExperience) {
      talentSpecialScore = { ...talentSpecialScore, experience: data?.scoreExperience }
    }
    return talentSpecialScore;
  }

  static toServer(data) {
    const profile = data.profile;
    const toReturn = {
      name: data.name || null,
      isIncognito: data.incognito ? true : false,
      isPublicProfile: data.public ? true : false,
      jobTitle: profile.details.jobTitle,
      jobTitleLevel: profile.details.jobTitleLevel,
      jobTitles: profile.details.jobTitles && profile.details.jobTitles.length ? profile.details.jobTitles : [],
      socialMedia: {
        linkedIn: profile.details.socials && profile.details.socials.linkedIn ? profile.details.socials.linkedIn : null,
        gitHub: profile.details.socials && profile.details.socials.gitHub ? profile.details.socials.gitHub : null,
        telegram: profile.details.socials && profile.details.socials.telegram ? profile.details.socials.telegram : null,
        stackOverflow: profile.details.socials && profile.details.socials.stackOverflow ? profile.details.socials.stackOverflow : null,
        dribble: profile.details.socials && profile.details.socials.dribble ? profile.details.socials.dribble : null,
        website: profile.details.socials && profile.details.socials.website ? profile.details.socials.website : null,
        twitter: null,
        youtube: null,
        facebook: null
      },
      workExperiences: profile.details.workExperiences && profile.details.workExperiences.length
        ? profile.details.workExperiences.filter(item => item.companyName) : [],
      location: {
        city: profile.details.city || null,
        country: profile.details.country || null
      },
      educationDegree: profile.details.educationDegree || null,
      educationField: profile.details.educationField,
      educationDescription: profile.details.educationDescription,
      about: {
        objective: profile.details.objective || null,
        achievements: profile.details.achievements || null,
        characteristics: profile.details.characteristics || null
      },
      salary: profile.details.salary ?? null,
      expectedSalary: {
        amount: profile.expectations?.salaryAmount ?? null,
        currency: profile.expectations?.salaryCurrency ?? null,
        period: profile.expectations?.salaryPeriod ?? null
      },
      workPlace: profile.expectations?.workPlace ?? null,
      employmentType: profile.expectations?.employmentType ?? null,
      relocationPossibility: profile.expectations?.relocation ?? null,
      domainsRequired: profile.expectations?.domains?.length ? profile.expectations.domains : [],
      domainsStopList: [],
      preferredCompanyType: profile.expectations?.preferredCompanyType ?? null,
      preferredCompanySize: profile.expectations?.preferredCompanySize ?? null,
      phone: {
        countryCode: profile.contacts?.phoneCode ?? null,
        phoneNumber: profile.contacts?.phone ?? null
      },
      languages: profile.details.languages && profile.details.languages.length
        ? profile.details.languages.filter(item => item.name) : []
    };
    return toReturn;
  }

  static toStore(data) {
    let telegramToken = null;
    if (data.messengerProviders && data.messengerProviders.length) {
      const telegram = data.messengerProviders.find(v => v.provider === 'telegram');
      if (telegram && telegram.userProviderToken) {
        telegramToken = telegram.userProviderToken;
      }
    }
    let main = {
      id: data.id,
      name: data.name,
      avatar: data.avatar ? data.avatar : environment.cloudinaryDefaultAvatar,
      email: data.email,
      roles: data.roles,
      onBoardingRole: data.onBoardingRole,
      incognito: data.profile && data.profile.isIncognito ? true : false,
      public: data.profile && data.profile.isPublicProfile ? true : false,
      publicLinkId: data.publicLinkId ? data.publicLinkId : null,
      score: data.profile && data.profile.score ? data.profile.score : 25,
      hardSkills: data.hardSkills ?? null,
      scoreExpectations: !data?.profile?.scoreListExpectatioins ? null
        : Object.keys(data?.profile.scoreListExpectatioins).map((key) => ({
          label: key,
          key: key.toLowerCase().replace(new RegExp(' ', 'g'), '_'),
          checked: !!data.profile?.scoreListExpectatioins[key]
        })),
      scoreExperience: !data?.profile?.scoreListExperience ? null
        : Object.keys(data.profile?.scoreListExperience).map((key) => ({
          label: key,
          key: key.toLowerCase().replace(new RegExp(' ', 'g'), '_'),
          checked: !!data.profile?.scoreListExperience[key]
        })),
      systemChatId: data.messageThreads && data.messageThreads.systemMessageThreadId ? data.messageThreads.systemMessageThreadId : null,
      files: data.profile && data.profile.files,
      defaultCv: data.defaultCv && data.defaultCv.fileUrl ? data.defaultCv : null,
      telegramToken
    }
    let profile = null;
    if (data.profile && main.roles && main.roles.length && main.roles[0] === USER_ROLES.talent) {
      const profData = data.profile;
      profile = {
        details: {
          jobTitle: profData.jobTitle ? profData.jobTitle : null,
          jobTitleLevel: profData.jobTitleLevel ? profData.jobTitleLevel : 'middle',
          jobTitles: profData.jobTitles ? profData.jobTitles : null,
          socials: profData.socialMedia,
          workExperiences: profData.workExperiences && profData.workExperiences.length
            ? profData.workExperiences
            : [{ companyName: null, isCurrentJob: false, startMonth: null, startYear: null, endMonth: null, endYear: null, description: null }],
          country: data.location && data.location.country ? data.location.country : null,
          city: data.location && data.location.city ? data.location.city : null,
          languages: profData.languages && profData.languages.length
            ? profData.languages : [{ name: null, level: null }],
          educationDegree: profData.educationDegree ? profData.educationDegree : null,
          educationField: profData.educationField ? profData.educationField : null,
          educationDescription: profData.educationDescription ? profData.educationDescription : null,
          salary: profData.salary ?? null,
          objective: profData.about && profData.about.objective ? profData.about.objective : null,
          achievements: profData.about && profData.about.achievements ? profData.about.achievements : null,
          characteristics: profData.about && profData.about.characteristics ? profData.about.characteristics : null
        },
        expectations: {
          salaryPeriod: profData.expectedSalary && profData.expectedSalary.period ? profData.expectedSalary.period : null,
          salaryCurrency: profData.expectedSalary && profData.expectedSalary.currency ? profData.expectedSalary.currency : 'USD',
          salaryAmount: profData.expectedSalary && profData.expectedSalary.amount ? profData.expectedSalary.amount : null,
          workPlace: profData && profData.workPlace || null,
          employmentType: profData && profData.employmentType || null,
          relocation: profData && profData.relocationPossibility !== null ? profData.relocationPossibility : null,
          domains: profData && profData.domainsRequired && profData.domainsRequired.length ? profData.domainsRequired : null,
          preferredCompanyType: profData && profData.preferredCompanyType || null,
          preferredCompanySize: profData && profData.preferredCompanySize || null,
        },
        contacts: {
          phoneCode: data.phone && data.phone.countryCode ? data.phone.countryCode : '+44',
          phone: data.phone && data.phone.phoneNumber ? data.phone.phoneNumber : null,
          telegram: profData && profData.socialMedia && profData.socialMedia.telegram ? profData.socialMedia.telegram : null
        }
      }
    };
    return { ...main, ...{ profile } };
  }

}

export class TalentUserSkillsAdapter {

  static toViewMerge(preset, userSkills) {
    if (preset && preset.length) {
      const clearSkillsAdds = { experience: 0, years: 0 };
      const prefilledTree = preset.map(branch => {
        if (!userSkills) {
          return { ...branch, skills: branch.skills.map(skill => ({ ...skill, ...clearSkillsAdds })) };
        }
        const canMergeBranch = userSkills.find(b => b.id === branch.id);
        if (canMergeBranch) {
          const skillsToAdd = branch.skills.filter(skill => !canMergeBranch.skills.find(s => s.id === skill.id))
            .map(val => ({ id: val.id, name: val.name, ...clearSkillsAdds }));
          return { ...branch, skills: [...canMergeBranch.skills, ...skillsToAdd] };
        } else {
          return { ...branch, skills: branch.skills.map(val => ({ id: val.id, name: val.name, ...clearSkillsAdds })) };
        }
      });

      if (!userSkills) { return prefilledTree; }
      const branchesToAdd = userSkills.filter(branch => !prefilledTree.find(b => b.id === branch.id));
      return [...prefilledTree, ...branchesToAdd];
    }
    return null;
  }

  static toView(branches) {
    if (branches && branches.length) {
      const toReturn = branches.map(branch => ({
        id: branch.id,
        name: branch.name,
        skills: branch.skills.map(skill => ({
          id: skill.id,
          name: skill.name,
          experience: 0,
          years: 0
        }))
      }))
      return toReturn;
    }
    return null;
  }

  static toServer(skills) {
    const toReturn = skills.reduce((filtered, item) => {
      if (item.skills && item.skills.length && item.skills.some(val => val.experience || val.years)) {
        filtered.push({ ...item, skills: item.skills.filter((item: any) => item.experience) });
      }
      return filtered;
    }, [])
    return toReturn.length ? toReturn : [];
  }

}

export class HmUserAdapter {

  static calculateHmScore(data) {
    const hmSpecialScore = {
      aboutYou: [
        { label: 'Your position', key: 'position', checked: !!(data.profile.aboutYou.jobPosition) },
        { label: 'Your mail', key: 'mail', checked: true },
        { label: 'Phone number', key: 'phone', checked: !!(data.profile.aboutYou.phone) }
      ],
      company: [
        { label: 'Company name', key: 'name', checked: !!(data.profile.company.companyName) },
        { label: 'Company logo', key: 'logo', checked: !!(data.profile.company.logo) },
        { label: 'About company', key: 'about', checked: !!(data.profile.company.companyAbout) },
        { label: 'Linkedin', key: 'linkedin', checked: !!(data.profile.company.socials && data.profile.company.socials.linkedin) },
        { label: 'Company type', key: 'type', checked: !!(data.profile.company.type) },
        { label: 'Company domain', key: 'domain', checked: !!(data.profile.company.domain) },
        { label: 'Company Size', key: 'size', checked: !!(data.profile.company.size) }
      ]
    };
    let total = 0;
    const aboutYouScore = hmSpecialScore.aboutYou.filter(item => item.checked).length * 10;
    total = total + aboutYouScore;
    const companyScore = hmSpecialScore.company.filter(item => item.checked).length * 10;
    total = total + companyScore;
    return { total, ...hmSpecialScore };
  }

  static companyToServer(data) {
    const toReturn = {
      id: data.id,
      about: data.companyAbout,
      type: data.type,
      domain: data.domain,
      size: data.size,
      location: {
        city: data.city
      },
      socialMedia: Object.keys(data.socials).map((key) => ({ name: key, url: data.socials[key] }))
    }
    return toReturn;
  }

  static toServer(data) {
    const profile = data.profile;
    const toReturn = {
      name: data.name || null,
      phone: {
        countryCode: profile.aboutYou.phoneCode || null,
        phoneNumber: profile.aboutYou.phone || null
      },
      jobPosition: profile.aboutYou.jobPosition || null,
      financeInfo: {
        residenceLocation: {
          country: profile.finance && profile.finance.country ? profile.finance.country : null,
          city: profile.finance && profile.finance.city ? profile.finance.city : null,
          addressStreetWithHouse: profile.finance && profile.finance.address ? profile.finance.address : null,
          postalCode: profile.finance && profile.finance.postalCode ? profile.finance.postalCode : null
        },
        bankDetails: {
          name: profile.finance && profile.finance.bankName ? profile.finance.bankName : null,
          address: profile.finance && profile.finance.bankAddress ? profile.finance.bankAddress : null,
          code: profile.finance && profile.finance.swiftCode ? profile.finance.swiftCode : null,
          owner: profile.finance && profile.finance.accountOwner ? profile.finance.accountOwner : null,
          accountNumber: profile.finance && profile.finance.accountNumber ? profile.finance.accountNumber : null,
          iban: profile.finance && profile.finance.iban ? profile.finance.iban : null
        }
      },
      socialMedia: {
        linkedIn: null,
        gitHub: null,
        telegram: profile.aboutYou.telegram || null,
        twitter: null,
        website: null,
        youtube: null,
        stackOverflow: null,
        dribble: null
      }
    };
    return toReturn;
  }

  static toStore(data) {
    let main = {
      id: data.id,
      avatar: data.avatar ? data.avatar : environment.cloudinaryDefaultAvatar,
      name: data.name,
      email: data.email,
      claims: data.claims,
      roles: data.roles,
      onBoardingRole: data.onBoardingRole,
      score: data.profile && data.profile.score ? data.profile.score : 10,
      systemChatId: data.messageThreads && data.messageThreads.systemMessageThreadId ? data.messageThreads.systemMessageThreadId : null,
      files: data.profile && data.profile.files,
      accountId: data.accountId
    };
    let profile = null;
    if (data.profile && main.roles && main.roles.length && main.roles[0] === USER_ROLES.hm) {
      const profData = data.profile;
      profile = {
        aboutYou: {
          jobPosition: profData.jobPosition ? profData.jobPosition : null,
          phoneCode: data.phone && data.phone.countryCode ? data.phone.countryCode : '+44',
          phone: data.phone && data.phone.phoneNumber ? data.phone.phoneNumber : null,
          telegram: profData && profData.socialMedia && profData.socialMedia.telegram ? profData.socialMedia.telegram : null
        },
        company: {
          id: profData.company && profData.company.id ? profData.company.id : null,
          isOwner: profData.company && profData.company.isOwner ? true : false,
          logo: profData.company && profData.company.logo ? profData.company.logo : null,
          companyName: profData.company && profData.company.name ? profData.company.name : null,
          companyAbout: profData.company && profData.company.about ? profData.company.about : null,
          type: profData.company && profData.company.type ? profData.company.type : null,
          domain: profData.company && profData.company.domain ? profData.company.domain : null,
          size: profData.company && profData.company.size ? profData.company.size : null,
          country: profData.company && profData.company.location && profData.company.location.country ? profData.company.location.country : null,
          city: profData.company && profData.company.location && profData.company.location.city ? profData.company.location.city : null,
          socials: profData.company && profData.company.socialMedia && profData.company.socialMedia.length
            ? profData.company.socialMedia.reduce((obj, item) => Object.assign(obj, { [item.name.toLowerCase()]: item.url }), {})
            : { facebook: null, linkedin: null, website: null }
        },
        finance: {
          country: profData.financeInfo && profData.financeInfo.residenceLocation
            && profData.financeInfo.residenceLocation.country ? profData.financeInfo.residenceLocation.country : null,
          city: profData.financeInfo && profData.financeInfo.residenceLocation
            && profData.financeInfo.residenceLocation.city ? profData.financeInfo.residenceLocation.city : null,
          address: profData.financeInfo && profData.financeInfo.residenceLocation
            && profData.financeInfo.residenceLocation.addressStreetWithHouse ? profData.financeInfo.residenceLocation.addressStreetWithHouse : null,
          postalCode: profData.financeInfo && profData.financeInfo.residenceLocation
            && profData.financeInfo.residenceLocation.postalCode ? profData.financeInfo.residenceLocation.postalCode : null,
          bankName: profData.financeInfo && profData.financeInfo.bankDetails
            && profData.financeInfo.bankDetails.name ? profData.financeInfo.bankDetails.name : null,
          bankAddress: profData.financeInfo && profData.financeInfo.bankDetails
            && profData.financeInfo.bankDetails.address ? profData.financeInfo.bankDetails.address : null,
          swiftCode: profData.financeInfo && profData.financeInfo.bankDetails
            && profData.financeInfo.bankDetails.code ? profData.financeInfo.bankDetails.code : null,
          accountOwner: profData.financeInfo && profData.financeInfo.bankDetails
            && profData.financeInfo.bankDetails.owner ? profData.financeInfo.bankDetails.owner : null,
          accountNumber: profData.financeInfo && profData.financeInfo.bankDetails
            && profData.financeInfo.bankDetails.accountNumber ? profData.financeInfo.bankDetails.accountNumber : null,
          iban: profData.financeInfo && profData.financeInfo.bankDetails
            && profData.financeInfo.bankDetails.iban ? profData.financeInfo.bankDetails.iban : null
        }
      }
    };
    return { ...main, ...{ profile } };
  }

}

export class AdminUserAdapter {
  static toStore(data) {
    return {
      id: data.id,
      claims: data.claims,
      role: USER_ROLES.admin,
      profileId: data.profileId,
      name: data.name,
      email: data.email,
      blocked: data.blocked || false,
      avatar: data.avatar,
      roles: data.roles,
      emailVerified: data.emailVerified,
      created: data.created,
      settings: data.settings || {},
      verifiedEmail: data.verifiedEmail,
      contacts: data.contacts || {},
      admin: true,
      incognito: false,
      public: true,
      notifications: data.notifications || [],
      notifyCount: data.notifyCount || 0,
      messageCount: data.messageCount || 0,
      appliesCount: data.appliesCount || 0,
      score: 100,
      scoreSpecial: {
        total: 100,
        experience: [],
        expectations: []
      }
    };
  }
}
